import { render, staticRenderFns } from "./CustomInputEditBrowse.vue?vue&type=template&id=1206b13f&"
import script from "./CustomInputEditBrowse.vue?vue&type=script&lang=js&"
export * from "./CustomInputEditBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports